export default {
  methods: {
    secondsToTime (seconds) {
      const value = Math.abs(seconds)
      const min = Math.floor((value) / 60)
      const sec = value - (min * 60)
      return `${seconds < 0 ? '-' : ''}${min < 10 ? '0' + min : min}:${sec < 10 ? '0' + sec : sec}`
    },
    getTime: function (dateTime) {
      let split = dateTime.split('/')
      let date = ''
      if (split.length >= 2) {
        date = split[1].trim()
      }
      return date
    },
    getDate: function (dateTime) {
      let split = dateTime.split('/')
      let date = ''
      if (split.length > 0) {
        date = split[0].trim()
      }
      return date
    }
  }
}
